import Link from "next/link";
import Image from "next/image";
import { FC } from "react";

import logo from "./logoMegaWhite.svg";
import { AsideMenu } from "./aside-menu";
import { AsideToggle } from "./aside-toggle";

export const Aside: FC = () => {
  return (
    <aside
      id="kt_aside"
      className="aside aside-dark aside-hoverable"
      data-kt-drawer="true"
      data-kt-drawer-name="aside"
      data-kt-drawer-activate="{default: true, lg: false}"
      data-kt-drawer-overlay="true"
      data-kt-drawer-width="{default:'200px', '300px': '250px'}"
      data-kt-drawer-direction="start"
      data-kt-drawer-toggle="#kt_aside_mobile_toggle">
      <div className="aside-logo flex-column-auto" id="kt_aside_logo">
        <Link href="/" data-kt-drawer-dismiss="true">
          <Image
            src={logo}
            alt="Logo Apolo Energia"
            width={170}
            height={35}
            className="logo-default"
            
          />
        </Link>
        <AsideToggle />
      </div>
      <div className="aside-menu flex-column-fluid">
        <AsideMenu />
      </div>
    </aside>
  );
};
